import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=13efdff8&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"
import style0 from "./Account.vue?vue&type=style&index=0&id=13efdff8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13efdff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13efdff8')) {
      api.createRecord('13efdff8', component.options)
    } else {
      api.reload('13efdff8', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=13efdff8&scoped=true", function () {
      api.rerender('13efdff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page2/Account.vue"
export default component.exports